import { clearApiClient } from './clearApiClient';

export interface RouterCreateConfigurationPayload {
  shortcut_group_id: string;
  shortcut_id: string;
  cluster_id: string;
  enhancer: 'general' | 'security' | 'adblock' | 'adsec';
  router_model: string;
  router_name: string;
}

export interface RouterCreateConfigurationResponse {
  device_id: string;
  router_name: string;
  node_login: string;
  node_password: string;
  hostname: string;
  port: number;
  enhancers: string[];
  router_configuration: string;
}

export const sendDownloadRouterConfigurationRequest = (payload: RouterCreateConfigurationPayload) =>
  clearApiClient
    .post<RouterCreateConfigurationResponse>('/web/v1/account/download-router-configuration', payload)
    .then((response) => response.data);

export const sendDownloadRouterConfigurationWireGuardRequest = (payload: RouterCreateConfigurationPayload) =>
  clearApiClient
    .post<RouterCreateConfigurationResponse>('/web/v1/account/wireguard-download-router-configuration', payload)
    .then((response) => response.data);

export const sendDeleteRouterConfigurationRequest = (routerDeviceId: string) =>
  clearApiClient.delete('/web/v1/shortcut/delete-router-configuration', {
    data: {
      device_id: routerDeviceId,
    },
    meta: {},
  });

export const sendRenameRouterRequest = (routerId: string, routerName: string) =>
  clearApiClient.put('/web/v1/account/device', {
    device_id: routerId,
    name: routerName,
  });

interface GetRouterConfigResponse {
  device_id: string;
  account_id: string;
  shortcut_group_id: string;
  shortcut_id: string;
  cluster_id: string;
  hostname: string;
  port: number;
  enhancer: RouterCreateConfigurationPayload['enhancer'];
  node_login: string;
  node_password: string;
  created_at: string;
  updated_at: string;
  router_configuration: string;
  protocol?: string;
}

export const sendRouterConfigurationRequest = (routerDeviceId: string) =>
  clearApiClient.post<GetRouterConfigResponse>('/web/v1/account/get-router-configuration', {
    device_id: routerDeviceId,
  });
